import { createApp } from 'vue'
import App from './App.vue'
import { createHead } from '@vueuse/head'
import router from './router'
import { createPinia } from 'pinia';
import VueLazyload from 'vue-lazyload';
import { pideOnAir } from './services/onair';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/tokens.scss';
import './assets/scss/type-classes.scss';
import './assets/scss/astra-styles.scss';
import './assets/scss/ds-tokens.scss';
import '@fortawesome/fontawesome-free/css/all.css';

// 🔇 Deshabilitar console.log/warn/debug (mantener solo console.error para errores críticos)
console.log = () => {};
console.debug = () => {};
console.warn = () => {};
// console.error se mantiene activo para errores críticos

// 🔴 **`onair.json` sale antes de montar la aplicación** en la portada y en Radio,
// que son las que lo pintan (08.10.26, la primera carga lenta). Queda en la
// memoria de `services/onair.js` y la vista lo encuentra hecho o en camino. No
// es un `<link rel="preload">` en `index.html` porque ese saldría en todas las
// páginas y Chrome avisa en consola de lo precargado y no usado.
if (location.pathname === '/' || location.pathname.startsWith('/radio')) {
  pideOnAir();
}

const app = createApp(App);
const head = createHead();
app.use(VueLazyload);
app.use(head);
app.use(createPinia());
app.use(router);
app.mount('#app');

// 📦 Registrar Service Worker para PWA y cache offline
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✅ Service Worker registrado:', registration.scope);

        // Forzar activación inmediata del nuevo SW sin esperar cierre de pestañas
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed') {
              // Enviar SKIP_WAITING para activar el nuevo SW inmediatamente
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((error) => {
        console.error('❌ Error registrando Service Worker:', error);
      });
  });
}

// 🔴 **Que nadie se quede con el service worker de ayer.**
//
// El navegador solo busca una versión nueva al CARGAR un documento, y esta web
// es de una sola página: moverse por ella no carga nada, así que una pestaña
// abierta puede seguir semanas con el de entonces. Lo preguntó el servidor el
// 21.09.26 (`ALTAS_SIGUEN_FALLANDO_WEB.md` §2) y tenía razón en preguntarlo: el
// arreglo del alta salió a las 11:48 y esa noche volvió a fallar un alta, con el
// viejo como primer sospechoso.
//
// Así que se pregunta al volver a la pestaña, con freno de diez minutos para no
// pedir el fichero a cada cambio de ventana. El relevo en sí ya estaba resuelto:
// el service worker hace `skipWaiting` al instalarse y `clients.claim` al
// activarse, así que en cuanto se descubre uno nuevo toma el mando sin esperar a
// que se cierren las pestañas.
if ('serviceWorker' in navigator) {
  const FRENO = 10 * 60 * 1000;
  let ultima = Date.now();

  document.addEventListener('visibilitychange', () => {
    if (document.hidden || Date.now() - ultima < FRENO) return;
    ultima = Date.now();
    navigator.serviceWorker.getRegistration().then((r) => r && r.update()).catch(() => {});
  });
}
